import { required, confirmed, length, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

// extend("nameValidator", {
//   message: "Please use only letters and spaces",
//   // Returns a boolean value
//   validate: value => {
//     return /^[a-zA-Z\s]*$/.test(value);
//   }
// });

// extend("SAcellphoneValidator", {
//   message: "Please use a valid phone number",
//   validate: value => {
//     return /^((?:\+27|27)|(?:\+44|44)|(?:\+267|267)|(?:\+233|233)|(?:\+233|233)|(?:\+1|1)|(?:\+880|880)|(?:\+91|91)|0)(\d{9}|\d{10})$/.test(
//       value
//     );
//   }
// });

// extend("agreeTermsValidator", {
//   message: "Please tick to show you have read the terms",
//   validate: value => {
//     return value;
//   }
// });

extend("password", {
  message: "Password should be at least 6 characters",
  validate: value => {
    return value.length >= 6;
  }
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("email", {
  ...email,
  message: "Please provide a valid email"
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match"
});

extend("length", {
  ...length,
  message: "This field must have "
});
